<template>
  <v-row class="overview">
    <template v-if="permissions.financial.overview">
      <v-col cols="12" lg="3" md="6" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.cashflow.overview.income }}</v-subheader>
          <v-icon x-large color="purple accent-1">mdi-cash-plus</v-icon>
          <span v-text="formatCurrency(value.income)"/>
        </div>
      </v-col>
      <v-col cols="12" lg="3" md="6" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.cashflow.overview.unpaid }}</v-subheader>
          <v-icon x-large color="amber">mdi-cash-lock</v-icon>
          <span v-text="formatCurrency(value.unpaid)"/>
        </div>
      </v-col>
      <v-col cols="12" lg="3" md="6" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.cashflow.overview.expenses }}</v-subheader>
          <v-icon x-large color="deep-orange accent-3">mdi-cash-minus</v-icon>
          <span v-text="formatCurrency(value.expenses)"/>
        </div>
      </v-col>
      <v-col cols="12" lg="3" md="6" sm="12">
        <div class="overview-info">
          <v-subheader>{{ lang.financial.cashflow.overview.profit }}</v-subheader>
          <v-icon x-large color="lime accent-4">mdi-cash-check</v-icon>
          <span v-text="formatCurrency(value.profit)"/>
        </div>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <span class="text-h4 pl-7 font-weight-medium">{{ lang.financial.cashflow.title }}</span>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
